import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-customer-product-service-setup',
  templateUrl: './customer-product-service-setup.component.html',
  styleUrls: ['./customer-product-service-setup.component.css']
})
export class CustomerProductServiceSetupComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
